import angular from 'angular';
import constants from 'app/constants';
import {
  loaderService,
  ssDialogService,
  vmSharedModelService
} from 'app/services';
import {
  alerts
} from 'app/components/global';

import controller from './edit-vendor-dialog.controller';
import template from './edit-vendor-dialog.html';

// Validation
import assessmentVendorMessagesTpl from './messages/vendor.messages.html';
import assessmentVendorEmailMessagesTpl from './messages/vendor.email.messages.html';
import assessmentVendorPhoneMessagesTpl from './messages/vendor.phone.messages.html';
import assessmentVendorWebsiteMessagesTpl from './messages/vendor.website.messages.html';


class dialogService {
  getOptions($event, { vendor }) {
    return {
      controller,
      controllerAs: 'editVendorDialogVM',
      locals: {
        vendor
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.editVendorDialog', [
  alerts,
  constants,
  loaderService,
  ssDialogService,
  vmSharedModelService,
])
  .service('bcp.editVendorDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('vendor.messages.html', assessmentVendorMessagesTpl);
    $templateCache.put('vendor.email.messages.html', assessmentVendorEmailMessagesTpl);
    $templateCache.put('vendor.phone.messages.html', assessmentVendorPhoneMessagesTpl);
    $templateCache.put('vendor.website.messages.html', assessmentVendorWebsiteMessagesTpl);
  })
  .name;
